import { v4 as getRandomID } from 'uuid'

import Box from '@mui/material/Box'

const DELTA = '0.4em'
export default function SnackbarMessage(
  messages: string[],
  title?: string
): JSX.Element {
  const nonEmptyMessages = messages.filter(m => m.trim().length > 0)
  const onlyOne = nonEmptyMessages.length === 1
  let withTitle = true

  if (nonEmptyMessages.length === 0) {
    if (title) {
      nonEmptyMessages.push(title)
      withTitle = false
    } else {
      return null // no title and no messages
    }
  }

  return (
    <Box
      flexDirection={'column'}
      justifyContent={'flex-start'}
      alignItems={'flex-start'}
    >
      {withTitle && <h3 style={{ margin: 0, marginLeft: DELTA }}>{title}</h3>}
      {nonEmptyMessages.map(m => (
        <p
          key={getRandomID()}
          style={{ margin: 0, padding: 0, paddingLeft: onlyOne ? 0 : DELTA }}
        >
          {m.endsWith(':') ? (
            <span style={{ fontSize: 16 }}>{m}</span>
          ) : (
            <span style={{ paddingLeft: onlyOne && !withTitle ? 0 : 16 }}>{`${
              withTitle ? '- ' : ''
            }${m}`}</span>
          )}
        </p>
      ))}
    </Box>
  )
}
